import { apiFetch } from './api';

/** Queue a failed channel reply again. The server pushes the new status. */
export const retryMessageDelivery = (sessionId: string, messageId: string) =>
  apiFetch<{ ok: boolean }>(`/api/conversations/${sessionId}/messages/${messageId}/retry-delivery`, {
    method: 'POST',
  });
